<template>
    <div class="mt-95 border-top">
        <v-container>
            <v-row class="align-center justify-md-space-between  justify-center  pb-5 pt-4 ">
                <v-col cols="12" md="7">
                    <div class="text-md-left text-center position-relative about-content ">
                        <h2 class="text-h2 font-weight-bold text-dark mb-4" data-aos="fade-up" data-aos-delay="200"
                            data-aos-duration="1000">Workers</h2>
                        <p class="text-body-1 text-muted bg-surface position-relative z-index1" data-aos="fade-up"
                            data-aos-delay="400" data-aos-duration="1000">
                            Treelet employs from the famous 1% of global tallent pool.
                            <br/>
                            A meritocracy based culture is nurtured at every level. 
                            <br/>
                            Compensation is aligned with contribution 
                            with a flexible cash/equity ratio.
                            <br/>                            
                         </p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <div class="pl-sm-6">
                        <v-card elevation="10">
                            <v-card-item class="px-12 py-6">
                                <div class="d-flex align-center  text-sm-left">
                                    <v-avatar size="60" color="lightprimary" class="me-6">
                                        <img src="/images/icon/icon-pricey.svg" alt="icon" width="30" />
                                    </v-avatar>
                                    <div>
                                        <h4 class="font-weight-bold text-dark pr-sm-3 my-sm-0 my-0 text-caption lh-normal">
                                            8</h4>
                                        <p class="text-muted text-subtitle-1">Roles</p>
                                    </div>
                                </div>
                            </v-card-item>
                            <v-divider></v-divider>
                            <v-card-item class="px-12 py-6">
                                <div class="d-flex align-center  text-sm-left">
                                    <v-avatar size="60" color="lightprimary" class="me-6">
                                        <img src="/images/icon/icon-folks.svg" alt="icon" width="30" />
                                    </v-avatar>
                                    <div>
                                        <h4 class="font-weight-bold text-dark pr-sm-3 my-sm-0 my-0 text-caption lh-normal">
                                            24</h4>
                                        <p class="text-muted text-subtitle-1">Available positions</p>
                                    </div>
                                </div>
                            </v-card-item>
                            <v-divider></v-divider>
                            <v-card-item class="px-12 py-6">
                                <div class="d-flex align-center  text-sm-left">
                                    <v-avatar size="60" color="lightprimary" class="me-6">
                                        <img src="/images/icon/icon-request.svg" alt="icon" width="30" />
                                    </v-avatar>
                                    <div>
                                        <h4 class="font-weight-bold text-dark pr-sm-3 my-sm-0 my-0 text-caption lh-normal">
                                            1.8M</h4>
                                        <p class="text-muted text-subtitle-1">Amount earned</p>
                                    </div>
                                </div>
                            </v-card-item>
                        </v-card>
                    </div>
                </v-col>
            </v-row>

            <div class="py-sm-16 py-6">
                <v-row>
                    <v-col cols="12" sm="5">
                        <div class="hover-card overflow-hidden rounded-md h-100">
                            <img src="/images/aboutpage/banner/about-1.jpg" class="zoom-in w-100 h-100" />
                        </div>
                    </v-col>
                    <v-col cols="12" sm="7">
                        <div class="hover-card overflow-hidden rounded-md h-100">
                            <img src="/images/aboutpage/banner/about-2.jpg" class="zoom-in w-100 h-100" />
                        </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</div>
</template>